import styled, { DefaultTheme } from 'styled-components'
import { Button } from 'antd'

export const StyledTableHeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const StyledTableHeaderButton = styled(Button)`
  align-items: center;
  display: flex !important;
  gap: 0;

  &.ant-btn-link {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.global.brandColor};
  }

  &:hover > * {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.color.cameo};
  }

  transition: none;

  > span {
    margin-left: 5px;
  }
`

export const StyledResponsiveTableHeaderButton = styled(Button)`
  align-items: center;
  display: flex !important;
  gap: 0;

  &.ant-btn-link {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.global.brandColor};
  }

  &:hover > * {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.color.cameo};
  }

  transition: none;

  > span {
    margin-left: 5px;
    display: none;

    @media ${({ theme }: { theme: DefaultTheme }) => theme.media.large} {
      display: inline;
    }
  }
`
